import React, {Component} from 'react';
import {connect} from 'react-redux';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import {
  loadControlItems,
  loadInterfaceSetupItems,
  updateControlItems,
  setStoreFormData,
  updateStoreFormData,
  clearStoreFormData,
  login,
  logout,
  sessionTimeout,
  updateUserProfile,
  updateUserProfileField,
  getAllUsers,
  setAlert,
  updateControlItemsDB,
  deleteControlItemDB,
} from 'core/redux/actions';
import {getFirstYearPremium, updateReportOptionsProfile} from 'custom/proQuote/redux/actions';

import Login from '../auth/Login';

import {withPCTranslation} from 'core/hocs';

import Routes from './Routes';

const mapStateToProps = (dataStore) => ({
  controlItems: dataStore.setupItems.controlItems,
  interfaceSetupItems: dataStore.setupItems.interfaceSetupItems,
  allSetupItems: dataStore.setupItems.allSetupItems,
  interfaceSetupArray: dataStore.setupItems.interfaceSetupArray,
  setupItems: dataStore.setupItems,
  firstYearPremium: dataStore.firstYearPremium,
  auth: dataStore.auth,
  routes: dataStore.routes,
});

const mapDispatchToProps = {
  // loadData,
  loadControlItems,
  updateControlItemsDB,
  deleteControlItemDB,
  loadInterfaceSetupItems,
  getFirstYearPremium,
  setAlert,
  updateControlItems,
  setStoreFormData,
  clearStoreFormData,
  updateStoreFormData,
  login,
  logout,
  sessionTimeout,
  updateUserProfile,
  updateUserProfileField,
  getAllUsers,
};

export const StoreConnector = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withPCTranslation(
    class extends Component {
      constructor() {
        super();
        this.state = {
          screenWidth: window.innerWidth || 0,
          sticky: 'scrollToTop',
          tabHeaderSticky: 'scrollToTop',
          policyHeaderSticky: 'scrollToTop',
          tabsSticky: 'scrollToTop',
        };
      }
      setScreenWidth = () => {
        this.setState({screenWidth: window.innerWidth});
        // setContentHeight();
      };
      toggleSticky = (e) => {
        console.log('ToggleSticky');
        const currentScrollPos = window.pageYOffset;
        let sticky = currentScrollPos > 0 ? 'sticky' : 'scrollToTop';
        if (this.state.sticky !== sticky) {
          this.setState({sticky});
          // setContentHeight();
        }

        /**
         * Tab Header sticky logic
         */
        let tabHeaderOffset = document.getElementById('tabHeader-id')
          ? document.getElementById('tabHeader-id').offsetHeight
          : 0;
        sticky = currentScrollPos > tabHeaderOffset ? 'sticky' : 'scrollToTop';
        if (this.state.tabHeaderSticky !== sticky) {
          this.setState({tabHeaderSticky: sticky});
          // setContentHeight();
        }

        /**
         * Policy Header sticky logic
         */
        let policyHeaderOffset = document.getElementById('policyheader-id')
          ? document.getElementById('policyheader-id').offsetHeight
          : 0;

        let policyHeaderSticky = currentScrollPos > tabHeaderOffset ? 'sticky' : 'scrollToTop';
        // }
        if (this.state.policyHeaderSticky !== policyHeaderSticky) {
          this.setState({policyHeaderSticky});
        }

        /**
         * Tabs sticky logic
         */
        let tabsSticky =
          currentScrollPos > policyHeaderOffset + tabHeaderOffset ? 'sticky' : 'scrollToTop';

        if (this.state.tabsSticky !== tabsSticky) {
          this.setState({tabsSticky});
        }
      };

      globalGetFocus = (event, storeFormData, elementItems, updateFormData) => {
        let {
          controlItems,
          interfaceSetupItems,
          updateControlItems,
          auth: {user},
        } = this.props;
        this.props.globalGetFocus(
          event,
          controlItems,
          storeFormData,
          elementItems,
          interfaceSetupItems,
          updateFormData,
          updateControlItems
        );
      };
      globalChange = (event, storeFormData, elementItems, updateFormData) => {
        let {
          controlItems,
          interfaceSetupItems,
          allSetupItems,
          inforceData,
          auth: {user},
          updateControlItems,
        } = this.props;
        this.props.globalChange(
          event,
          user,
          controlItems,
          storeFormData,
          elementItems,
          interfaceSetupItems,
          allSetupItems,
          updateFormData,
          updateControlItems,
          inforceData
        );
      };
      globalClick = (name, storeFormData, elementItems, updateFormData) => {
        let {
          controlItems,
          interfaceSetupItems,
          allSetupItems,
          inforceData,
          auth: {user},
          updateControlItems,
        } = this.props;
        this.props.globalClick(
          name,
          user,
          controlItems,
          storeFormData,
          elementItems,
          interfaceSetupItems,
          allSetupItems,
          updateFormData,
          updateControlItems,
          inforceData
        );
      };
      globalLostFocus = (
        event,
        storeFormData,
        elementItems,
        updateFormData,
        updateControlItems
      ) => {
        let {
          controlItems,
          interfaceSetupItems,
          inforceData,
          auth: {user},
        } = this.props;
        this.props.globalLostFocus(
          event,
          user,
          controlItems,
          storeFormData,
          elementItems,
          interfaceSetupItems,
          updateFormData,
          updateControlItems,
          inforceData
        );
      };
      onLoad = (storeFormData, elementItems, updateFormData) => {
        let {
          controlItems,
          interfaceSetupItems,
          allSetupItems,
          inforceData,
          updateControlItems,
          auth: {user},
        } = this.props;
        this.props.onLoad(
          user,
          controlItems,
          storeFormData,
          elementItems,
          interfaceSetupItems,
          allSetupItems,
          updateFormData,
          updateControlItems,
          inforceData
        );
      };
      render() {
        return (
          <Routes
            {...this.props}
            globalGetFocus={this.globalGetFocus}
            globalChange={this.globalChange}
            globalClick={this.globalClick}
            globalLostFocus={this.globalLostFocus}
            onLoad={this.onLoad}
            screenWidth={this.state.screenWidth}
            sticky={this.state.sticky}
            policyHeaderSticky={this.state.policyHeaderSticky}
            tabHeaderSticky={this.state.tabHeaderSticky}
            tabsSticky={this.state.tabsSticky}
          />
        );
      }
      componentDidMount() {
        window.addEventListener('resize', this.setScreenWidth);
        window.addEventListener('scroll', this.toggleSticky);
      }
      componentWillUnmount() {
        window.removeEventListener('resize', this.setScreenWidth);
        window.removeEventListener('scroll', this.toggleSticky);
      }
      // componentDidUpdate(prevProps, prevState) {
      //   if (!this.props.controlItems && this.props.auth.isAuthenticated) {
      //     let {user} = this.props.auth;

      //     //Temporary fix. It gets called multiple times due to change in language and classes on body element.
      //     // if (this.props.setupItems && !this.props.setupItems.isDataLoading) {
      //     //   this.props.loadControlItems();
      //     // }

      //     //console.log("user:", user);
      //     if (user && user.loadProfile === true) {
      //       user.loadProfile = false;
      //       if (user['fontSize'] === 'Large') {
      //         document.body.classList.add('altFont');
      //       } else if (user['fontSize'] === 'Small') {
      //         document.body.classList.remove('altFont');
      //       }
      //     }
      //   }
      // }
    }
  )
);
